import { getMomentDateString } from '@/utils/dateUtil';
import { CISO_SAMC_API } from '@/api';

const state = {
  detailData: [],
  summaryData: [],
  params: null,
};

const actions = {
  async fetchInvoiceSubAllocCompareDetails({ commit }, request) {
    commit('setDetailData', []);
    commit('setSummaryData', []);
    const params = {
      scs: request.coordinatorListSelected,
      invoiceDate: request.tradeDateSelected,
    };
    try {
      const { data: { data } } = await CISO_SAMC_API.get('/eim-sub-allocation/invoice-suballoc-compare', { params });
      commit('setDetailData', data.details);
      commit('setSummaryData', data.summary);
    } catch (error) {
      console.error(error);
      this.$notify({ message: 'Failed to Load EIM-Sub Allocation details', type: 'error' });
    }
  },
  reset({ commit }) {
    commit('setDetailData', []);
    commit('setSummaryData', []);
    commit('setParams', []);
  },
};

const mutations = {
  setDetailData(state, value) {
    if (value) value.forEach((x) => { x.tradingDate = getMomentDateString(x.tradingDate); });
    state.detailData = value;
  },
  setSummaryData(state, value) {
    if (value) {
      value.forEach((x) => {
        x.invoiceDate = getMomentDateString(x.invoiceDate);
        x.billPeriodStart = getMomentDateString(x.billPeriodStart);
        x.billPeriodEnd = getMomentDateString(x.billPeriodEnd);
      });
    }
    state.summaryData = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
